<script>
/**
 * @Author: Andrea Dittler | webspezi.com
 * @Date:   2023-04-03 19:58:45
 * @Last Modified by:   Andrea Dittler | webspezi.com
 * @Last Modified time: 2023-04-09 08:59:09
 */

</script>

<template>
  <div>
    <h1 class="special-heading light-special mb-5">Neue Internetpräsenz</h1>
    <div role="" class="row justify-content-center align-items-start  wsFlexTyp-standard" id="Kombiblk_block1__6">
      <div class=" col-12 col-sm-6 col-lg-7 ">
        <div class="text-white  text-center">

        </div>


      </div>
    </div>
    <div role="" class="row justify-content-center align-items-start  wsFlexTyp-standard">
      <div class="wsFlex col-12 col-sm-8 col-md-6 col-lg-4 has-wsBlocksInfoBox KombiEbene1 ">

        <div class="milchglas position-relative" id="milchglas" ref="milchglas">
          <div class="innen" style="cursor: pointer;">
            <div class="iconbox iconbox-light iconbox-center zentriert">
              <div class="iconbox-wrapper">
                <div class="iconbox-icon"><i class="fa-globe fa-6x fal text-white"></i></div>
                <div class="iconbox-content">

                  <p></p>
                  <p>Hier entsteht eine neue Internetpäsenz. </p>

                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>





    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onBeforeUnmount, computed, onMounted, onUpdated, watch } from 'vue'
import { applyMilchglasEffect } from './shared.js'

onBeforeMount(() => {
  window.addEventListener('resize', applyMilchglasEffect);
  window.addEventListener('scroll', applyMilchglasEffect);
  //applyMilchglasEffect();
});
onUpdated(() => {
  applyMilchglasEffect();
});
onMounted(() => {
  applyMilchglasEffect();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', applyMilchglasEffect);
  window.removeEventListener('scroll', applyMilchglasEffect);
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div {
  font-size: clamp(16px, 1.3vw, 25px);
  font-weight: 400;
}
</style>
